import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Quote } from "@cinch-labs/design-system";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
export var TrustPilotQuote = function(blok) {
    var quote = blok.quote, author = blok.author, rating = blok.rating;
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, storyblokEditable(blok)), {
        children: /*#__PURE__*/ _jsx(Quote, {
            text: quote,
            author: author,
            rating: Number.parseInt(rating, 10)
        })
    }));
};
export default TrustPilotQuote;
